import { api } from './api';

export interface ImageRegenerateRequest {
  postContent: string;
  brandId: string;
  personaId: string;
  aspect_ratio: string;
  style_type: string;
  provider?: string; // Optional provider field (imagen, ideogram, etc.)
}

export interface ImageGenerateRequest {
  brandId: string;
  postContent: string; // Changed from 'prompt' to 'postContent' to match API expectation
  tone: string;
  platforms: string[];
  aspect_ratio: string;
  style_type: string;
  provider?: string; // Optional provider field (imagen, ideogram, etc.)
}

export interface ImageRegenerateResponse {
  success: boolean;
  imageUrl: string;
  prompt: string;
  style: string;
}

export interface ImageGenerateResponse {
  success: boolean;
  imageUrl: string;
  prompt: string;
  style: string;
}

export const regenerateImageFromPost = async (request: ImageRegenerateRequest): Promise<ImageRegenerateResponse> => {
  try {
    // Debug: Check if we have a token
    const token = localStorage.getItem('token');
    console.log('🔐 Token present:', !!token);
    console.log('📝 Request payload:', request);
    
    // Transform the request to match the new API format
    const apiRequest: ImageGenerateRequest = {
      brandId: request.brandId,
      postContent: request.postContent, // Use postContent directly
      tone: 'professional', // Default tone, could be made configurable
      platforms: ['instagram', 'linkedin'], // Default platforms, could be made configurable
      aspect_ratio: convertAspectRatioFormat(request.aspect_ratio),
      style_type: request.style_type
    };
    
    const response = await api.post('/ai-coach/image/generate', apiRequest);
    console.log('✅ API Response:', response.data);
    return response.data;
  } catch (error) {
    console.error('❌ Error regenerating image:', error);
    console.error('Error response:', (error as any)?.response);
    throw error;
  }
};

export const generateImage = async (request: ImageGenerateRequest): Promise<ImageGenerateResponse> => {
  try {
    // Debug: Check if we have a token
    const token = localStorage.getItem('token');
    console.log('🔐 Token present:', !!token);
    console.log('📝 Image generation request payload:', request);
    
    const response = await api.post('/ai-coach/image/generate', request);
    console.log('✅ Image generation API Response:', response.data);
    return response.data;
  } catch (error) {
    console.error('❌ Error generating image:', error);
    console.error('Error response:', (error as any)?.response);
    throw error;
  }
};

// Helper function to convert image size to aspect ratio
export const convertImageSizeToAspectRatio = (imageSize: string): string => {
  const aspectRatioMap: Record<string, string> = {
    'square': '1x1',
    '9:16': '9x16',
    '4:5': '4x5'
  };
  return aspectRatioMap[imageSize] || '1x1';
};

// Helper function to convert aspect ratio from old format to new format
export const convertAspectRatioFormat = (aspectRatio: string): string => {
  const conversionMap: Record<string, string> = {
    'ASPECT_1_1': '1x1',
    'ASPECT_9_16': '9x16',
    'ASPECT_4_5': '4x5',
    'ASPECT_3_4': '4x5'  // Legacy: redirect old 3:4 to new 4:5
  };
  return conversionMap[aspectRatio] || aspectRatio;
};

// Helper function to convert image style to style type
export const convertImageStyleToStyleType = (imageStyle: string): string => {
  // API expects lowercase values: auto, realistic, design, 3d, artistic
  return imageStyle;
}; 